<template>
  <bk-popup
    class="breachPenaltyConfirmPopup" 
		position="bottom" 
		showClose
		:show="show" 
		:header-info="headerInfo" 
		:footerInfo="footerInfo"
    @close="close"
  >
    <bk-view class="view-box">
			<bk-view class="view-creditCard">
				<bk-view class="view-leftInfo">
					<bk-lang code="appointment_breachPenaltyConfirm_payment"></bk-lang>
					<showPayIcon :cardInfo="maSeReserveItem?.paymentFlow?.cardDetail"/>
				</bk-view>
				<bk-view class="view-rightInfo">
					<span v-if="maSeReserveItem?.paymentFlow?.cardDetail?.holderName">{{ maSeReserveItem.paymentFlow.cardDetail.holderName }}</span>
				</bk-view>
			</bk-view>
			<bk-view class="view-info">
				<bk-lang class="view-name" code="appointment_breachPenaltyConfirm_theBreachPenalty"></bk-lang>	
				<bk-view class="view-list">
					<bk-view class="view-item">
						<bk-lang code="appointment_breachPenaltyConfirm_type"></bk-lang>
						<template v-if="curRows.status===3">
							<bk-lang  code="appointment_breachPenaltyConfirm_lateCancellation"></bk-lang>
							<span v-if="timeText">&nbsp;&nbsp;{{ timeText }}</span>
						</template>
						<bk-lang v-if="curRows.status===9" code="appointment_breachPenaltyConfirm_noShow"></bk-lang>
					</bk-view>
					<bk-view class="view-item">
						<bk-lang code="appointment_breachPenaltyConfirm_amount"></bk-lang>
						<bk-price color="red"  fontSize="20px" :value="formData?.amount" :unitText="curShop.currencySymbol"></bk-price>
						<span v-if="totalAmountText">&nbsp;&nbsp;{{ totalAmountText }}</span>
					</bk-view>
				</bk-view>
			</bk-view>
    </bk-view>
  </bk-popup>
</template>

<script>
	import { reserveReq, shopReq } from '@/reqService';
	import showPayIcon from './showPayIcon/showPayIcon.vue';
	
	export default {
		name:'breachPenaltyConfirm',
		components:{ showPayIcon },
		props:{
			show:Boolean,
			reserveInfo:Object,
			curRows:Object,
		},
		data (){
			return {
				formData:{},
				headerInfo:{
					langCode_title: 'appointment_breachPenaltyConfirm_title'
				},
				curShop:{}
			};
		},
		computed:{
			chargingRule (){
				const { cancelRuleItem, authChargeRuleNoShow } = this.formData;
				const { status } = this.curRows;
				return status===9 ? authChargeRuleNoShow : cancelRuleItem;
			},
			maSeReserveItem (){
				const { reservePaymentList=[] } = this.reserveInfo?.reserveCharge || {};
				return reservePaymentList[0];
			},
			timeText (){
				const cancelRuleItem = this.chargingRule;

				let unit_langCode = {
					days:'date_day',
					hours:'date_h',
					minutes:'date_min',
				}[cancelRuleItem.timeUnit];

				let unit = this.$bk_getTextWithLangCode(unit_langCode);

				let res = this.$bk_resvReplaceTemplateStr('appointment_breachPenaltyConfirm_within', {
					unit, 
					time: cancelRuleItem.timeValue
				});

				return res;
			},
			totalAmountText (){
				if(!this.chargingRule || this.chargingRule?.type==1){
					return '';
				}
				let res = this.$bk_resvReplaceTemplateStr('appointment_breachPenaltyConfirm_totalAmount', {
					number: this.$bk_formatPrice(this.chargingRule.value * 100)
				});
				return res;
			},
			footerInfo (){
				return {
					show:true,
					buttons:[
						{langCode: 'appointment_breachPenaltyConfirm_confirmCharging', key: 'charge', action: this.handleItemAction},
					]
				};
			}
		},
		watch:{
			show (val){
				if(val){
					this.initData();
				}
			}
		},
		methods:{
			initData (){
				this.requestPenaltyInfo();
			},
			async requestPenaltyInfo (){
				const { status } = this.curRows;
				const { compId } = this.reserveInfo;
				let res = await reserveReq.requestPenaltyInfo(this, { ...this.reserveInfo, status });
				this.formData = res?.reserveCharge || {};

				const resShop = await shopReq.requestGetShopDetailByCompId(this, compId);

				this.curShop = resShop
			},
			handleItemAction (){
				this.$emit('confirm');
			}
		}
	};
</script>

<style lang="less">
@import './breachPenaltyConfirm.less';
</style>